export const ternaryValue = <T>(condition: boolean, value1: T, value2: T): T =>
  condition ? value1 : value2

export const orValue = <T>(value: T, defaultValue: T): T =>
  value || defaultValue

export const andValue = (value: unknown, defaultValue: unknown): unknown =>
  value && defaultValue
